import React from "react";

import { FormHelperText, TextField } from "@mui/material";

import { getIdsArray, isValidCreativeID } from "../../services/utils/validator";

type CreativeIDsComponentProps = {
  setCreativeIDs: (ids: string[]) => void;
};
const CreativeIDsFilter: React.FC<CreativeIDsComponentProps> = ({ setCreativeIDs }) => {
  const [ids, setIds] = React.useState("");
  const [idError, setIdError] = React.useState(true);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const idArray = getIdsArray(value);
    const isValid = idArray.every(isValidCreativeID);

    setCreativeIDs(isValid ? idArray : []);
    setIdError(!isValid);
    setIds(value);
  };

  return (
    <>
      <TextField
        label="Creative IDs"
        multiline
        minRows={8}
        placeholder="Enter comma-seperated Creative IDs i.e. 4405e302-ad1f-4e2c-b607-9c48d8a8bf22, f00e2ed5-d7d6-4d52-91df-a22787fa4769"
        fullWidth
        value={ids}
        data-testid="creative-id-input"
        onChange={handleChange}
      />
      {idError && <FormHelperText error={true}>Invalid list of Creative IDs.</FormHelperText>}
    </>
  );
};

export default CreativeIDsFilter;
